module.exports = __webpack_public_path__ + "img/motion_graphics.39be85ff.gif";